import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4fc93c36"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "setting-main-top" }
const _hoisted_2 = { class: "main_title title_padding" }
const _hoisted_3 = { class: "header-left" }
const _hoisted_4 = { class: "ion-activatable ripple-parent btn-back" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "arrow_b",
  src: "/assets/icon/btn_back.png",
  srcset: "/assets/icon/btn_back@2x.png 2x,/assets/icon/btn_back@3x.png 3x"
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, " 투자 자산 현황 ", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "empty-margin" }, null, -1))
const _hoisted_8 = {
  id: "myAsset__mainTop",
  class: "main_top"
}
const _hoisted_9 = { class: "main_content" }
const _hoisted_10 = { class: "row_top space-between" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "총 투자금액", -1))
const _hoisted_12 = { class: "medium" }
const _hoisted_13 = { class: "strong" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" 원 ")
const _hoisted_15 = { class: "row space-between" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gray" }, " 조합원 자격 보유 ", -1))
const _hoisted_17 = {
  key: 0,
  class: "strong gray"
}
const _hoisted_18 = {
  key: 1,
  class: "strong"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " 원", -1))
const _hoisted_20 = { class: "row space-between" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gray" }, " 조합 설립중 ", -1))
const _hoisted_22 = {
  key: 0,
  class: "strong gray"
}
const _hoisted_23 = {
  key: 1,
  class: "strong"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " 원", -1))
const _hoisted_25 = { class: "row space-between" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gray" }, " EXIT ", -1))
const _hoisted_27 = {
  key: 0,
  class: "strong gray"
}
const _hoisted_28 = {
  key: 1,
  class: "strong"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " 원", -1))
const _hoisted_30 = {
  id: "myAsset__generateBox",
  key: 'ing',
  class: "content"
}
const _hoisted_31 = { class: "content_top space-between" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "조합 설립중", -1))
const _hoisted_33 = { class: "col_left" }
const _hoisted_34 = { class: "c_logo" }
const _hoisted_35 = ["src"]
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inset-border" }, null, -1))
const _hoisted_37 = { class: "col_right" }
const _hoisted_38 = { class: "space-between" }
const _hoisted_39 = { class: "regular bold" }
const _hoisted_40 = { class: "space-between" }
const _hoisted_41 = { class: "gray" }
const _hoisted_42 = { class: "space-between" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "진행 단계", -1))
const _hoisted_44 = { class: "last_child space-between" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "투자 금액", -1))
const _hoisted_46 = { class: "strong" }
const _hoisted_47 = /*#__PURE__*/_createTextVNode(" 원")
const _hoisted_48 = {
  id: "myAsset__ownBox",
  key: 'own',
  class: "content"
}
const _hoisted_49 = { key: 0 }
const _hoisted_50 = { class: "content_top space-between" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "조합원 자격 보유", -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content_info_title" }, [
  /*#__PURE__*/_createTextVNode(" * 수익은 직전 투자 가치 혹은 시중 거래가를 바탕으로 "),
  /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "엔젤리그가 계산한 기업가치를 기준"),
  /*#__PURE__*/_createTextVNode("으로 합니다. 기업가치를 계산할 수 없는 경우 표기하지 않습니다. ")
], -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content_info_title" }, [
  /*#__PURE__*/_createTextVNode(" * "),
  /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "주식의 수"),
  /*#__PURE__*/_createTextVNode("는 조합이 보유한 총 주식수 대비 투자금액을 계산하여 표기하는 참고 숫자이며, "),
  /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "소수점 한자리까지 반올림"),
  /*#__PURE__*/_createTextVNode("하여 표기합니다. ")
], -1))
const _hoisted_54 = ["onClick"]
const _hoisted_55 = { class: "col_left" }
const _hoisted_56 = { class: "c_logo" }
const _hoisted_57 = ["src"]
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inset-border" }, null, -1))
const _hoisted_59 = { class: "col_right" }
const _hoisted_60 = { class: "space-between partnership_name" }
const _hoisted_61 = { class: "regular bold" }
const _hoisted_62 = { class: "space-between" }
const _hoisted_63 = { class: "gray" }
const _hoisted_64 = { class: "gray" }
const _hoisted_65 = { class: "space-between" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "투자 금액", -1))
const _hoisted_67 = { class: "strong" }
const _hoisted_68 = /*#__PURE__*/_createTextVNode(" 원")
const _hoisted_69 = { class: "space-between" }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "추정 수익 금액", -1))
const _hoisted_71 = {
  key: 0,
  class: "main_14R red"
}
const _hoisted_72 = { class: "num_14BK" }
const _hoisted_73 = /*#__PURE__*/_createTextVNode(" 원 ")
const _hoisted_74 = {
  key: 1,
  class: "main_14R blue"
}
const _hoisted_75 = { class: "num_14BK" }
const _hoisted_76 = /*#__PURE__*/_createTextVNode(" 원 ")
const _hoisted_77 = {
  key: 2,
  class: "main_14R gray"
}
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "num_14BK" }, "0", -1))
const _hoisted_79 = /*#__PURE__*/_createTextVNode(" 원 ")
const _hoisted_80 = [
  _hoisted_78,
  _hoisted_79
]
const _hoisted_81 = {
  key: 3,
  class: "main_14R gray"
}
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "num_14BK" }, "-", -1))
const _hoisted_83 = /*#__PURE__*/_createTextVNode(" 원 ")
const _hoisted_84 = [
  _hoisted_82,
  _hoisted_83
]
const _hoisted_85 = { class: "space-between" }
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "추정 수익률", -1))
const _hoisted_87 = {
  key: 0,
  class: "main_14R red"
}
const _hoisted_88 = { class: "num_14BK" }
const _hoisted_89 = /*#__PURE__*/_createTextVNode("% ")
const _hoisted_90 = {
  key: 1,
  class: "main_14R blue"
}
const _hoisted_91 = { class: "num_14BK" }
const _hoisted_92 = /*#__PURE__*/_createTextVNode("% ")
const _hoisted_93 = {
  key: 2,
  class: "main_14R gray"
}
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "num_14BK" }, "0", -1))
const _hoisted_95 = /*#__PURE__*/_createTextVNode("% ")
const _hoisted_96 = [
  _hoisted_94,
  _hoisted_95
]
const _hoisted_97 = {
  key: 3,
  class: "num_14BK gray"
}
const _hoisted_98 = { class: "space-between" }
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "주당 평균 구매가격", -1))
const _hoisted_100 = { class: "strong" }
const _hoisted_101 = /*#__PURE__*/_createTextVNode(" 원")
const _hoisted_102 = { class: "space-between" }
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "현재 보유 자격", -1))
const _hoisted_104 = { class: "strong" }
const _hoisted_105 = /*#__PURE__*/_createTextVNode("주")
const _hoisted_106 = { key: 1 }
const _hoisted_107 = {
  class: "empty_box purple_bg",
  style: {"background-image":"url('/assets/image/purple_bg.png')"}
}
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "box_title" }, " 참여하신 조합이 없습니다. ", -1))
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "box_info" }, " 매력적인 스타트업의 주주가 되어보세요! ", -1))
const _hoisted_110 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "angel_man",
    src: "/assets/image/orange_richie.png",
    srcset: "/assets/image/orange_richie@2x.png 2x,/assets/image/orange_richie@3x.png 3x"
  })
], -1))
const _hoisted_111 = {
  id: "myAsset__exitBox",
  key: 'exit',
  class: "content"
}
const _hoisted_112 = { key: 0 }
const _hoisted_113 = { class: "content_top space-between" }
const _hoisted_114 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "EXIT", -1))
const _hoisted_115 = { class: "col_left" }
const _hoisted_116 = { class: "c_logo" }
const _hoisted_117 = ["src"]
const _hoisted_118 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inset-border" }, null, -1))
const _hoisted_119 = { class: "col_right" }
const _hoisted_120 = { class: "space-between" }
const _hoisted_121 = { class: "regular bold" }
const _hoisted_122 = { class: "space-between" }
const _hoisted_123 = { class: "gray" }
const _hoisted_124 = { class: "status_badge_red" }
const _hoisted_125 = { class: "status_badge" }
const _hoisted_126 = {
  class: "status_badge",
  style: {"background-color":"#00B7B9"}
}
const _hoisted_127 = { class: "space-between" }
const _hoisted_128 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "투자 금액", -1))
const _hoisted_129 = { class: "strong" }
const _hoisted_130 = /*#__PURE__*/_createTextVNode("원")
const _hoisted_131 = { class: "space-between" }
const _hoisted_132 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "주당 평균 구매가격", -1))
const _hoisted_133 = { class: "strong" }
const _hoisted_134 = /*#__PURE__*/_createTextVNode(" 원")
const _hoisted_135 = { key: 1 }
const _hoisted_136 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "empty_box blue_bg",
  style: {"background-image":"url('/assets/image/blue_bg.png')"}
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "box_title" }, " EXIT 조합이 없습니다. "),
  /*#__PURE__*/_createElementVNode("div", { class: "box_info" }, " 지분 거래에 도전해보세요! "),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "angel_man",
      src: "/assets/image/blue_richie.png",
      srcset: "/assets/image/blue_richie@2x.png 2x,/assets/image/blue_richie@3x.png 3x"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "box_opacity box_btn" }, " 지분 보유 현황 보기 > ")
], -1))
const _hoisted_137 = [
  _hoisted_136
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_ripple_effect = _resolveComponent("ion-ripple-effect")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ag_icon = _resolveComponent("ag-icon")!
  const _component_ag_text_s = _resolveComponent("ag-text-s")!
  const _component_ag_box_s = _resolveComponent("ag-box-s")!
  const _component_regist_sell_stake_modal = _resolveComponent("regist-sell-stake-modal")!
  const _component_view_my_stake = _resolveComponent("view-my-stake")!
  const _component_link_account_modal = _resolveComponent("link-account-modal")!
  const _component_collect_club_deals = _resolveComponent("collect-club-deals")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_router_link, {
                  to: _ctx.fromUrl,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$clickTrackEvent({'clickArea':'헤더', 'clickContent':'뒤로가기', clickScreen: _ctx.clickScreen})))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, [
                      _hoisted_5,
                      _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                    ])
                  ]),
                  _: 1
                }, 8, ["to"]),
                _hoisted_6
              ])
            ])
          ]),
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$filters.currency(_ctx.totalAsset)), 1),
                  _hoisted_14
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _createElementVNode("div", null, [
                  (_ctx.partnershipComplete.totalAsset === 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_17, "-"))
                    : (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.$filters.currency(_ctx.partnershipComplete.totalAsset)), 1)),
                  _hoisted_19
                ])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _hoisted_21,
                _createElementVNode("div", null, [
                  (_ctx.partnershipCollecting.totalAsset === 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_22, "-"))
                    : (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(_ctx.$filters.currency(_ctx.partnershipCollecting.totalAsset)), 1)),
                  _hoisted_24
                ])
              ]),
              _createElementVNode("div", _hoisted_25, [
                _hoisted_26,
                _createElementVNode("div", null, [
                  (_ctx.exit.totalAsset === 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_27, "-"))
                    : (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(_ctx.$filters.currency(_ctx.exit.totalAsset)), 1)),
                  _hoisted_29
                ])
              ])
            ])
          ]),
          (_ctx.partnershipCollecting.list && _ctx.partnershipCollecting.list.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("div", null, [
                    _hoisted_32,
                    _createTextVNode(" " + _toDisplayString(_ctx.partnershipCollecting.list.length), 1)
                  ])
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.partnershipCollecting.list, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item,
                    class: "content_box"
                  }, [
                    _createElementVNode("div", _hoisted_33, [
                      _createElementVNode("div", _hoisted_34, [
                        _createElementVNode("img", {
                          src: item.companyLogo ? item.companyLogo : '/assets/icon/company_default_img.png',
                          onerror: "this.src='/assets/icon/company_default_img.png'",
                          class: "img-responsive img-circle"
                        }, null, 8, _hoisted_35),
                        _hoisted_36
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_37, [
                      _createElementVNode("div", _hoisted_38, [
                        _createElementVNode("span", _hoisted_39, _toDisplayString(item.partnershipName), 1)
                      ]),
                      _createElementVNode("div", _hoisted_40, [
                        _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.$filters.transDate(item.foundAt)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_42, [
                        _hoisted_43,
                        _createElementVNode("div", null, _toDisplayString(item.processStatusName), 1)
                      ]),
                      _createElementVNode("div", _hoisted_44, [
                        _hoisted_45,
                        _createElementVNode("div", null, [
                          _createElementVNode("span", _hoisted_46, _toDisplayString(_ctx.$filters.currency(Math.floor(item.asset))), 1),
                          _hoisted_47
                        ])
                      ])
                    ])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (_openBlock(), _createElementBlock("div", _hoisted_48, [
            (_ctx.partnershipComplete.list && _ctx.partnershipComplete.list.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                  _createElementVNode("div", _hoisted_50, [
                    _createElementVNode("div", null, [
                      _hoisted_51,
                      _createTextVNode(" " + _toDisplayString(_ctx.partnershipComplete.list.length), 1)
                    ])
                  ]),
                  _hoisted_52,
                  _hoisted_53,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.partnershipComplete.list, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: item,
                      class: "content_box",
                      onClick: ($event: any) => {_ctx.$clickTrackEvent({'clickArea':'조합원 자격 보유', 'clickContent':`${item.partnershipName}`, clickScreen: _ctx.clickScreen});_ctx.viewDetail(item.partnershipId)}
                    }, [
                      _createElementVNode("div", _hoisted_55, [
                        _createElementVNode("div", _hoisted_56, [
                          _createElementVNode("img", {
                            src: item.companyLogo ? item.companyLogo : '/assets/icon/company_default_img.png',
                            onerror: "this.src='/assets/icon/company_default_img.png'",
                            class: "img-responsive img-circle"
                          }, null, 8, _hoisted_57),
                          _hoisted_58
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_59, [
                        _createElementVNode("div", _hoisted_60, [
                          _createElementVNode("span", _hoisted_61, _toDisplayString(item.partnershipName) + " >", 1)
                        ]),
                        _createElementVNode("div", _hoisted_62, [
                          _createElementVNode("div", _hoisted_63, _toDisplayString(item.foundAt) + " 설립 ", 1),
                          _createElementVNode("div", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.myStatus, (status, idx) => {
                              return (_openBlock(), _createElementBlock("span", {
                                key: (status, idx),
                                class: _normalizeClass(status === '참여' ? 'blue' : 'green')
                              }, [
                                _createTextVNode(_toDisplayString(status) + " ", 1),
                                _withDirectives(_createElementVNode("span", _hoisted_64, " · ", 512), [
                                  [_vShow, item.myStatus.length !== idx+1]
                                ])
                              ], 2))
                            }), 128))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_65, [
                          _hoisted_66,
                          _createElementVNode("div", null, [
                            _createElementVNode("span", _hoisted_67, _toDisplayString(_ctx.$filters.currency(Math.floor(item.asset))), 1),
                            _hoisted_68
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_69, [
                          _hoisted_70,
                          (parseFloat(item.incomingProfit) > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                                _createElementVNode("span", _hoisted_72, "+" + _toDisplayString(_ctx.$filters.currency(item.incomingProfit)), 1),
                                _hoisted_73
                              ]))
                            : _createCommentVNode("", true),
                          (parseFloat(item.incomingProfit) < 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                                _createElementVNode("span", _hoisted_75, _toDisplayString(_ctx.$filters.currency(item.incomingProfit)), 1),
                                _hoisted_76
                              ]))
                            : (parseFloat(item.incomingProfit) === 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_77, _hoisted_80))
                              : (!item.incomingProfit)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_81, _hoisted_84))
                                : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_85, [
                          _hoisted_86,
                          (parseFloat(item.incomingProfitRate) > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_87, [
                                _createElementVNode("span", _hoisted_88, _toDisplayString(_ctx.$filters.currency(item.incomingProfitRate)), 1),
                                _hoisted_89
                              ]))
                            : _createCommentVNode("", true),
                          (parseFloat(item.incomingProfitRate) < 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_90, [
                                _createElementVNode("span", _hoisted_91, _toDisplayString(_ctx.$filters.currency(item.incomingProfitRate)), 1),
                                _hoisted_92
                              ]))
                            : (parseFloat(item.incomingProfitRate) === 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_93, _hoisted_96))
                              : (!item.incomingProfitRate)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_97, " - % "))
                                : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_98, [
                          _hoisted_99,
                          _createElementVNode("div", null, [
                            _createElementVNode("span", _hoisted_100, _toDisplayString(_ctx.$filters.currency(Math.floor(item.avgPrice))), 1),
                            _hoisted_101
                          ])
                        ]),
                        _createVNode(_component_ag_box_s, { css: {
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'flex-end',
                  alignItems: 'center',
                } }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ag_box_s, { css: {dp: 'flex', alignItems: 'center', color: 'gray3', typography: 'main12r', bg: 'bg1', borderRadius: '4px', padding:'4px 8px'} }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ag_icon, { name: "businessOutline" }),
                                _createVNode(_component_ag_text_s, { css: {ml:'5px'} }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" 시총 " + _toDisplayString(_ctx.numberToKorean(item.avgPrice*item.totalStockAmount)) + "원 상당 ", 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024),
                        _createElementVNode("div", _hoisted_102, [
                          _hoisted_103,
                          _createElementVNode("div", null, [
                            _createElementVNode("span", _hoisted_104, _toDisplayString((+item.sumQty).toFixed(2)), 1),
                            _hoisted_105
                          ])
                        ])
                      ])
                    ], 8, _hoisted_54))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_106, [
                  _createElementVNode("div", _hoisted_107, [
                    _hoisted_108,
                    _hoisted_109,
                    _hoisted_110,
                    _createElementVNode("div", {
                      class: "box_btn",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => {_ctx.$clickTrackEvent({'clickArea':'참여하신 조합이 없습니다', 'clickContent':`참여 가능 조합 보러가기`, clickScreen: _ctx.clickScreen});_ctx.clubDealAllOpen=true;})
                    }, " 참여 가능 조합 보러가기 > ")
                  ])
                ]))
          ])),
          (_openBlock(), _createElementBlock("div", _hoisted_111, [
            (_ctx.exit.list && _ctx.exit.list.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_112, [
                  _createElementVNode("div", _hoisted_113, [
                    _createElementVNode("div", null, [
                      _hoisted_114,
                      _createTextVNode(" " + _toDisplayString(_ctx.exit.list.length), 1)
                    ])
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.exit.list, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: item,
                      class: "content_box"
                    }, [
                      _createElementVNode("div", _hoisted_115, [
                        _createElementVNode("div", _hoisted_116, [
                          _createElementVNode("img", {
                            src: item.companyLogo ? item.companyLogo : '/assets/icon/company_default_img.png',
                            onerror: "this.src='/assets/icon/company_default_img.png'",
                            class: "img-responsive img-circle"
                          }, null, 8, _hoisted_117),
                          _hoisted_118
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_119, [
                        _createElementVNode("div", _hoisted_120, [
                          _createElementVNode("span", _hoisted_121, _toDisplayString(item.partnershipName), 1)
                        ]),
                        _createElementVNode("div", _hoisted_122, [
                          _createElementVNode("div", _hoisted_123, _toDisplayString(_ctx.$filters.transDate(item.createAt.slice(0,10))), 1),
                          _withDirectives(_createElementVNode("div", _hoisted_124, " 상장 ", 512), [
                            [_vShow, true]
                          ]),
                          _withDirectives(_createElementVNode("div", _hoisted_125, " 개인EXIT ", 512), [
                            [_vShow, false]
                          ]),
                          _withDirectives(_createElementVNode("div", _hoisted_126, " 조합EXIT ", 512), [
                            [_vShow, false]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_127, [
                          _hoisted_128,
                          _createElementVNode("div", null, [
                            _createElementVNode("span", _hoisted_129, _toDisplayString(_ctx.$filters.currency(Math.floor(item.asset))), 1),
                            _hoisted_130
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_131, [
                          _hoisted_132,
                          _createElementVNode("div", null, [
                            _createElementVNode("span", _hoisted_133, _toDisplayString(_ctx.$filters.currency(Math.floor(item.qtyPerAveragePrice))), 1),
                            _hoisted_134
                          ])
                        ])
                      ])
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_135, _hoisted_137))
          ])),
          _createVNode(_component_regist_sell_stake_modal, {
            "open-type": _ctx.sellOpenType,
            "is-open": _ctx.stakeSellOpen,
            onCloseWithResult: _ctx.branchResult,
            onClose: _cache[2] || (_cache[2] = () => _ctx.stakeSellOpen = false)
          }, null, 8, ["open-type", "is-open", "onCloseWithResult"]),
          _createVNode(_component_view_my_stake, {
            "open-type": _ctx.viewOpenType,
            "is-open": _ctx.viewMyStakeOpen,
            onClose: _cache[3] || (_cache[3] = () => _ctx.viewMyStakeOpen = false)
          }, null, 8, ["open-type", "is-open"]),
          _createVNode(_component_link_account_modal, {
            "model-value": _ctx.linkAccountModal,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = (value) => _ctx.linkAccountModal = value),
            onComplete: _cache[5] || (_cache[5] = ($event: any) => (_ctx.linkAccountModal = false))
          }, null, 8, ["model-value"]),
          _createVNode(_component_collect_club_deals, {
            "model-value": _ctx.clubDealAllOpen,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = (value) => _ctx.clubDealAllOpen = value)
          }, null, 8, ["model-value"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}